import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import ResourcePage from '../views/ResourcePage.vue';
import Customer from '../views/Customer.vue';
import Display from '../views/Display.vue';
import SessionDetail from '../views/SessionDetail.vue';
import CustomerProduct from '../views/CustomerProduct.vue';
import Licenses from '../views/Licenses.vue';
import SessionProduct from '../views/SessionProduct.vue';
import ParticipantFalls from '../views/ParticipantFalls.vue';
import SessionSummary from '../views/SessionSummary.vue';
import Holidays from '../views/Holidays.vue';
import Email from '../views/Email.vue';
import PlannerCustomer from '../views/PlannerCustomer.vue';
import FFeFeed from '../views/FFeFeed.vue';
import PensionListing from '../views/PensionListing.vue';
import TreatmentsListing from '../views/TreatmentsListing.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/customers',
    name: 'Customer',
    component: Customer
  },
  {
    path: '/products',
    name: 'Product',
    component: CustomerProduct
  },
  {
    path: '/licenses',
    name: 'License',
    component: Licenses
  },
  {
    path: '/sessionProduct',
    name: 'SessionProduct',
    component: SessionProduct
  },
  {
    path: '/sessionSummary',
    name: 'SessionSummary',
    component: SessionSummary
  },
  {
    path: '/holidays',
    name: 'Holidays',
    component: Holidays
  },
  {
    path: '/Email',
    name: 'Email',
    component: Email
  },
  {
    path: '/plannerCustomer',
    name: 'PlannerCustomer',
    component: PlannerCustomer
  },
  {
    path: '/falls',
    name: 'ParticipantFalls',
    component: ParticipantFalls
  },
  {
    path: '/ffe',
    name: 'FFeFeed',
    component: FFeFeed
  },
  {
    path: '/pensions',
    name: 'PensionListing',
    component: PensionListing
  },
  {
    path: '/treatments',
    name: 'TreatmentsListing',
    component: TreatmentsListing
  },
  {
    path: '/display/:workspace',
    name: 'Display',
    component: Display
  },
  {
    path: '/session/:session_id',
    name: 'SessionDetail',
    component: SessionDetail
  },
  {
    path: '/:type/:uuid?',
    name: 'ResourcePage',
    component: ResourcePage
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
